require("../reviews-content/reviews-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminReviewsContent() {
  const store = window.NMReviewsContent;
  if (!store || !adminRoot || window.NMAdminReviewsContent) return;

  const reviewsList = document.querySelector("[data-reviews-list-admin]");
  const reviewsCount = document.querySelector("[data-reviews-count]");
  const reviewsStat = document.querySelector("[data-reviews-stat-value]");
  const createBtn = document.querySelector("[data-reviews-create]");
  const modal = document.querySelector("[data-reviews-modal]");
  const form = document.querySelector("[data-reviews-form]");
  const formTitle = document.querySelector("[data-reviews-form-title]");
  const imageInput = document.querySelector("#reviews-image");
  const imageData = document.querySelector("[data-reviews-image-data]");
  const imagePreview = document.querySelector("[data-reviews-image-preview]");
  const imageReset = document.querySelector("[data-reviews-image-reset]");

  let editingId = null;

  function clearErrors() {
    form?.querySelectorAll("[data-reviews-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-reviews-error]");
      if (error) error.hidden = true;
    });
  }

  function showError(name) {
    const field = form?.querySelector(`[data-reviews-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-reviews-error]");
    if (error) error.hidden = false;
  }

  function updatePreview(src) {
    if (!imagePreview) return;
    const img = imagePreview.querySelector("img");
    if (!src) {
      imagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    imagePreview.hidden = false;
  }

  function closeModal() {
    if (modal) modal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingId = null;
    if (form) form.reset();
    if (imageData) imageData.value = "";
    if (imageInput) imageInput.value = "";
    clearErrors();
    updatePreview("");
  }

  function openModal(reviewId) {
    if (!form) return;
    const review = reviewId
      ? store.getReviews().find((item) => item.id === reviewId)
      : null;
    editingId = review ? review.id : null;

    form.elements.date.value = review?.date || "";
    form.elements.user.value = review?.user || "";
    form.elements.post.value = review?.post || "";
    form.elements.text.value = review?.text || "";
    if (imageData) imageData.value = review?.image || "";
    if (imageInput) imageInput.value = "";
    updatePreview(review?.image || "");
    if (formTitle) {
      formTitle.textContent = review ? "Изменить отзыв" : "Новый отзыв";
    }
    clearErrors();
    if (modal) modal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function renderReviewsAdmin() {
    const items = store.getReviews();
    if (reviewsCount) reviewsCount.textContent = `Отзывов: ${items.length}`;
    if (reviewsStat) reviewsStat.textContent = String(items.length);
    if (!reviewsList) return;

    if (!items.length) {
      reviewsList.innerHTML = `
        <div class="admin-panel__services-empty">
          <p class="admin-panel__services-empty-title">Пока нет отзывов</p>
          <p class="admin-panel__hint p3">Добавьте первый отзыв — он появится в слайдере на главной</p>
        </div>
      `;
      return;
    }

    reviewsList.innerHTML = items.map((review) => {
      const preview = review.image
        ? `<div class="admin-panel__service-card-media"><img src="${store.escapeHtml(review.image)}" alt="" width="96" height="96"></div>`
        : `<div class="admin-panel__service-card-media"></div>`;

      return `
        <article class="admin-panel__service-card">
          ${preview}
          <div class="admin-panel__service-card-body">
            <div class="admin-panel__service-card-top">
              <h4 class="admin-panel__service-card-title">${store.escapeHtml(review.user)}</h4>
              <div class="admin-panel__service-card-tags">
                ${review.date ? `<span class="admin-panel__service-tag">${store.escapeHtml(review.date)}</span>` : ""}
              </div>
            </div>
            <p class="admin-panel__service-card-desc">${store.escapeHtml(review.text)}</p>
          </div>
          <div class="admin-panel__service-card-actions">
            <button class="admin-panel__action-btn" type="button" data-reviews-edit="${store.escapeHtml(review.id)}">Изменить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-reviews-delete="${store.escapeHtml(review.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!form) return;
    clearErrors();

    const user = String(form.elements.user.value || "").trim();
    const text = String(form.elements.text.value || "").trim();

    if (!user) {
      showError("user");
      return;
    }
    if (!text) {
      showError("text");
      return;
    }

    store.upsertReview({
      id: editingId || store.createId(),
      date: String(form.elements.date.value || "").trim(),
      user,
      post: String(form.elements.post.value || "").trim(),
      text,
      image: String(imageData?.value || "").trim(),
    });

    store.hydratePublicReviews();
    closeModal();
    renderReviewsAdmin();
  }

  createBtn?.addEventListener("click", () => openModal(null));
  form?.addEventListener("submit", handleSubmit);

  document.querySelectorAll("[data-reviews-modal-close]").forEach((el) => {
    el.addEventListener("click", closeModal);
  });

  reviewsList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-reviews-edit]");
    const deleteBtn = event.target.closest("[data-reviews-delete]");
    if (editBtn) openModal(editBtn.getAttribute("data-reviews-edit"));
    if (deleteBtn) {
      const id = deleteBtn.getAttribute("data-reviews-delete");
      const review = store.getReviews().find((item) => item.id === id);
      // eslint-disable-next-line no-alert
      if (!review || !window.confirm(`Удалить отзыв «${review.user}»?`)) return;
      store.deleteReview(id);
      store.hydratePublicReviews();
      if (editingId === id) closeModal();
      renderReviewsAdmin();
    }
  });

  if (imageInput) {
    imageInput.addEventListener("change", () => {
      const file = imageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (imageData) imageData.value = result;
        updatePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  imageReset?.addEventListener("click", () => {
    if (imageData) imageData.value = "";
    if (imageInput) imageInput.value = "";
    updatePreview("");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (modal && !modal.hidden) closeModal();
  });

  document.addEventListener("nm:admin-view", (event) => {
    if (event.detail?.route === "reviews") renderReviewsAdmin();
  });

  window.NMAdminReviewsContent = {
    renderReviewsAdmin,
    closeModal,
  };

  renderReviewsAdmin();
}

if (adminRoot) {
  initAdminReviewsContent();
  window.setTimeout(initAdminReviewsContent, 0);
}
